var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilePlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7 2.5H5.9a1.7 1.7 0 00-1.7 1.7v13.6a1.7 1.7 0 001.7 1.7h10.2a1.7 1.7 0 001.7-1.7V7.6l-5.1-5.1z",
    stroke: "#BDC1CB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7 2.5v5.1h5.1M11 16.1V11M8.45 13.55h5.1",
    stroke: "#BDC1CB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjIgMjIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTEyLjcgMi40OTk5NEg1Ljg5OTk2QzUuNDQ5MDkgMi40OTk5NCA1LjAxNjY5IDIuNjc5MDUgNC42OTc4OCAyLjk5Nzg2QzQuMzc5MDcgMy4zMTY2NyA0LjE5OTk2IDMuNzQ5MDcgNC4xOTk5NiA0LjE5OTk0VjE3Ljc5OTlDNC4xOTk5NiAxOC4yNTA4IDQuMzc5MDcgMTguNjgzMiA0LjY5Nzg4IDE5LjAwMkM1LjAxNjY5IDE5LjMyMDggNS40NDkwOSAxOS40OTk5IDUuODk5OTYgMTkuNDk5OUgxNi4xQzE2LjU1MDggMTkuNDk5OSAxNi45ODMyIDE5LjMyMDggMTcuMzAyIDE5LjAwMkMxNy42MjA5IDE4LjY4MzIgMTcuOCAxOC4yNTA4IDE3LjggMTcuNzk5OVY3LjU5OTk0TDEyLjcgMi40OTk5NFoiIHN0cm9rZT0iI0JEQzFDQiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KICA8cGF0aCBkPSJNMTIuNzAwMSAyLjQ5OTk0VjcuNTk5OTRIMTcuODAwMSIgc3Ryb2tlPSIjQkRDMUNCIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgogIDxwYXRoIGQ9Ik0xMSAxNi4xVjExIiBzdHJva2U9IiNCREMxQ0IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CiAgPHBhdGggZD0iTTguNDUgMTMuNTVIMTMuNTUiIHN0cm9rZT0iI0JEQzFDQiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgFilePlus as ReactComponent };